// src/components/navigation/TopNav.js
import React from 'react';
import { redirectToAuth } from '../../utils/auth';
import { Navbar, Nav, Button } from 'react-bootstrap';

const TopNav = ({
  account,
  handleDisconnectWallet,
  handleConnectWallet,
  handleSogniLogin,
  handleSogniLogout,
  sogniClientReady,
  isSogniLoggedIn,
  sogniUsername
}) => {
  const encodedRedirect = encodeURIComponent('https://nft.sogni.ai/callback');
  const signupUrl = `https://app.sogni.ai/signup/?redirect=${encodedRedirect}&authMode=cookies&ts=${Date.now()}`;

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="px-3">
      {/* ⬇️  Renamed collection */}
      <Navbar.Brand href="/" style={{ color: '#fff' }}>
        Sogni Prospect Worker Collection
      </Navbar.Brand>

      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ms-auto">
          {isSogniLoggedIn && account && (
            <Navbar.Text className="me-3">
              Connected as: <strong>{sogniUsername}</strong> ({account})
            </Navbar.Text>
          )}

          {account ? (
            <Button variant="outline-success" onClick={handleDisconnectWallet}>
              Disconnect
            </Button>
          ) : (
            <>
              {/* Invisible but clickable “Connect Wallet” */}
              <Button
                variant="secondary"
                onClick={handleConnectWallet}
                style={{
                  marginRight: '10px',
                  opacity: 0,
                  pointerEvents: 'auto',
                  height: '40px',
                  overflow: 'hidden'
                }}
              >
                Connect Wallet
              </Button>

              {isSogniLoggedIn ? (
                <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                  <Button variant="success" disabled>
                    @{sogniUsername || 'User'}
                  </Button>
                  <Button variant="outline-light" onClick={handleSogniLogout}>Logout</Button>
                </div>
              ) : (
                <Button
                  variant="success"
                  onClick={() => redirectToAuth('login')}
                  disabled={!sogniClientReady}
                >
                  {sogniClientReady ? 'Sogni Login' : 'Loading Sogni...'}
                </Button>
              )}
            </>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default TopNav;
